(function (HomepageYotpoReviews) {
  
    const initYotpoMods = () => {
        (function CF41f() {
            
            console.log('CF 41 firing');
            
            function addContent(){
                // Set Reference Elements
                let referenceElements = [];
                if (checkReferenceElements(referenceElements) == false) {
                  setTimeout(addContent, 100);
                  return false;
                }
                $('html').addClass('cf-41-v2');
                  $('.cf-41-v2 .headline').text('Real Reviews From Our Customers');
                $('.homepage-reviews-section').each(function(i, obj) {
                    switchSliderToSlick($(obj).attr('id'));
                    reorganizeContent('#' + $(obj).attr('id'));
                });
                showHideTooltip();
            }
            function showHideTooltip() {
                $("body").on('mouseenter', '.single-review .right-side .carousel-review-body .carousel-read-more', function() {
                    showTooltip($(this));
                });
                
                $("body").on('click', '.single-review .right-side .carousel-review-body .carousel-read-more', function() {
                    showTooltip($(this));
                });
                
                $("body").on('mouseleave', '.single-review .right-side .carousel-review-body .carousel-read-more', function() {
                    hideTooltip($(this));
                });
            }
            function showTooltip(readMore) {
                let sliderWrapper = $(readMore).closest('.homepage-yotpo-reviews-main-container');
                let slickItem = $(readMore).parent().parent().parent().parent().parent();
                
                let tooltip = $(sliderWrapper).find('.yotpo-tool-tip');
                tooltip.find('.tool-tip-header').html($(slickItem).find('.carousel-review-title').html());
                tooltip.find('.tool-tip-content').html($(slickItem).find('.carousel-review-body').html());
                $(tooltip).css('display', 'block');
                
                let sliderWidth = $(sliderWrapper).find('.cf-slider').width();
                let offset = ($(window).width() - sliderWrapper.width()) / 2;
                let tooltipLeft = slickItem.offset().left - offset;
                console.log(offset, tooltipLeft);
                let tooltipTop = $(slickItem).find('.review-header').outerHeight() + $(slickItem).find('.carousel-review-body').outerHeight() + $(sliderWrapper).find('#carousel-top-panel').outerHeight();
                
                if($(window).width() < 1024) {
                    if($(window).width() < 768) {
                        tooltipLeft = (($(sliderWrapper).find('.yotpo-display-wrapper').width() - 300) / 2) + (($(sliderWrapper).width() - sliderWidth) / 2);
                    }
                    $(tooltip).css('left', tooltipLeft + 'px');
                    tooltipTop = tooltipTop + 40;
                    $(tooltip).css('top', tooltipTop + 'px');
                    $(tooltip).addClass('arrow-up');
                } else {
                    tooltipLeft = tooltipLeft + $(slickItem).find('.product-link-container').width() + $(slickItem).find('.carousel-read-more').width() + 40;
                    if(sliderWidth - tooltipLeft < 350 && $(window).width() - sliderWrapper.width() < 300) {
                        $(tooltip).css('left', 'auto');
                        let tooltipRight = $(slickItem).find('.right-side').width() + 55;
                        $(tooltip).css('right', tooltipRight + 'px');
                        $(tooltip).addClass('arrow-right');
                    } else {
                        $(tooltip).css('left', tooltipLeft + 'px');
                    }
                    tooltipTop = tooltipTop;
                    $(tooltip).css('top', tooltipTop + 'px');
                }
            }
            function hideTooltip(readMore) {
                let sliderWrapper = $(readMore).closest('.homepage-yotpo-reviews-main-container');
                let tooltip = $(sliderWrapper).find('.yotpo-tool-tip');
                $(tooltip).css('display', 'none');
                $(tooltip).css('left', 'auto');
                $(tooltip).css('right', 'auto');
                $(tooltip).removeClass('arrow-right');
                $(tooltip).removeClass('arrow-up');
            }
            function switchSliderToSlick(selector) {
                let selectorId = `#${selector}`;
                $(selectorId).addClass('slider-wrapper');
                let reviews = [];
                let reviewsHtml = '';
                let sliderInt = setInterval(sliderLoaded, 100);
                function sliderLoaded() {
                    if($(selectorId + ' .single-carousel').length) {
                        clearInterval(sliderInt);
                        $(selectorId + ' .single-carousel').each(function() {
                            if(!reviews.includes($(this).attr('data-review-id'))) {
                                reviews.push($(this).attr('data-review-id'));
                                reviewsHtml += '<div class="single-review">' + $(this).find('.big-version').html() + '</div>';
                            }
                        });
                        $(selectorId + ' .scroller').remove();
                        $(selectorId + ' #carousel-top-panel').after(`<div class="cf-slider" id="${selector}-slider">${reviewsHtml}</div>`);
                        slickSlider(`${selectorId}-slider`);
                    }
                }
            }
            function reorganizeContent(selector) {
                let reviewsInt = setInterval(sliderInitialized, 100);
                function sliderInitialized() {
                    if($(selector).find('.single-review').length) {
                        clearInterval(reviewsInt);
                        $(selector).find('.single-review').each(function() {
                            $(this).prepend('<div class="review-header"></div>');
                            $(this).find('.carousel-review-title').appendTo($(this).find('.review-header'));
                            $(this).find('.carousel-review-title').text('“' + $(this).find('.carousel-review-title').text().trim() + '”');
                            $(this).find('.stars-container').prependTo($(this).find('.review-header'));
                            
                            let reviewed = '<div class="reviewd-on">Reviewed on' + $(this).find('.stars-container .carousel-review-date').text() + '</div>';
                            $(this).find('.review-header').append(reviewed);
                            $(this).find('.stars-container .carousel-review-date').remove();
                            
                            $(this).find('.yotpo-stars').after('<span class="verified-buyer"><img loading="lazy" src="https://cdn-3.convertexperiments.com/uf/10034918/10033640/1654187324checkmark_red.png" alt="Verified Buyer">Verified Buyer</span>');
                            
                            let reviewContent = $(this).find('.carousel-review-body');
                            if(reviewContent.find('.carousel-read-more').length) {
                                let reviewContentHtml = reviewContent.html().replace('<div class="carousel-read-more" tabindex="0">Read More</div>', '');
                                $(this).find('.carousel-review-body').html('“' + reviewContentHtml + '”' + '<div class="carousel-read-more" tabindex="0">Read More</div>');
                            } else {
                                $(this).find('.carousel-review-body').html('“' + reviewContent.text() + '”');
                            }
                        });
                    }
                }
            }
            function slickSlider(selector) {
                jQuery(selector).slick({
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true,
                    slidesToShow: 3,
                    verticalSwiping: false,
                    autoplay: false,
                    vertical: false,
                    infinite: true,
                    responsive: [
                        {
                          breakpoint: 1024,
                          settings: {
                            slidesToShow: 2
                          }
                        },
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: 2
                          }
                        },
                        {
                          breakpoint: 767,
                          settings: {
                            slidesToShow: 1
                          }
                        }
                    ]
                });
            }
            function checkReferenceElements(referenceElements) {
                let refElementsAvailable = true;
                // If No Reference Elements, skip
                if (referenceElements.length == 0) {
                    return true;
                }
                // If has reference Elements
                referenceElements.map(function (element) {
                    if (element.length == 0) {
                    refElementsAvailable = false;
                    }
                });
                return refElementsAvailable;
            }
        
            $(document).ready(function() {
                addContent();
            });
        })();

    }

    const listenForLoaded = () => {
        addEventListener('DOMContentLoaded', (event) => {initYotpoMods()});
    }
  
    // Public / Init
    HomepageYotpoReviews.init = function () {
        listenForLoaded();
    };
  
  }(window.HomepageYotpoReviews = window.HomepageYotpoReviews || {}, jQuery));